import React from 'react';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, roles }) => {
  const [auth, , loading] = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get('access_token');
    if (!loading) {
      if (!token) {
        navigate('/');
      } else if (roles && roles !== auth.user_type) {
        navigate('/page-not-found');
      }
    }
  }, [auth, loading, navigate, roles]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return children;
};

export default ProtectedRoute;
